import * as React from 'react';

import FilePdf16 from './FilePdf16';

export const filePdf16 = () => <FilePdf16 />;

export default {
    title: 'Icon/Fill/FilePdf16',
    component: FilePdf16,
    parameters: {
        notes: "`import FilePdf16 from 'box-ui-elements/es/icon/fill/FilePdf16';`",
    },
};
